import { BRAND_NAMES } from '@/utils/get-brand.util';

export const IMAGES_PATH = `/public/assets/images/`;

export const SKINS = {
  whitelabel: 'whitelabel',
  europcar: 'europcar',
  goldcar: 'goldcar',
  interrent: 'interrent',
} as const;

export const BROKER_COLORS = {
  whitelabel: {
    primary: '#007bff',
    secondary: '#fff',
  },
  goldcar: {
    primary: '#cfd636',
    secondary: '#333',
  },
  europcar: {
    primary: '#299900',
    secondary: '#fff',
  },
} as const;

export const LOGOS = {
  [BRAND_NAMES.goldcar]: {
    image: 'goldcar_logo.svg',
  },
  [BRAND_NAMES.europcar]: {
    image: 'europcar_logo.svg',
  },
  [BRAND_NAMES.keyngo]: {
    image: 'keyngo_logo.svg',
    subtitle: 'header.logoSubtitle',
  },
} as const;

export const BRANDS = {
  [BRAND_NAMES.goldcar]: 'Goldcar',
  [BRAND_NAMES.europcar]: 'Europcar',
  [BRAND_NAMES.keyngo]: 'Key’n Go',
} as const;

export const LANGUAGE_SELECTOR_OPTIONS = {
  [BRAND_NAMES.goldcar]: {
    flagClasses: '',
  },
  [BRAND_NAMES.keyngo]: {
    flagClasses: '',
  },
  [BRAND_NAMES.europcar]: {
    flagClasses: 'flag-xs',
  },
} as const;

export const BRAND_SERVICE = {
  [BRAND_NAMES.keyngo]: 'Key’n Go',
  [BRAND_NAMES.goldcar]: 'Key’n Go',
  [BRAND_NAMES.europcar]: 'Europcar Fast Track',
} as const;

const defaultMetaColors = {
  primary: '#cfd637',
  secondary: '#062022',
} as const;

const europcarMetaColor = {
  primary: '#f7f7f7',
  secondary: '#f7f7f7',
} as const;

export const META_THEME_COLOR = {
  [BRAND_NAMES.keyngo]: defaultMetaColors,
  [BRAND_NAMES.goldcar]: defaultMetaColors,
  [BRAND_NAMES.europcar]: europcarMetaColor,
} as const;

export const CUSTOM_COLORS = {
  corporatePrimary: 'corporate-primary',
  corporateSecondary: 'corporate-secondary',
} as const;
